// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AccountInformationResponse,
    ObjectIdResponse,
    ObjectNoResponse,
    ProviderClaimEligibility,
    PublicPatientDashboardPayload,
    PublicRawStringPayload,
    TemporaryUrl,
    PublicPatientDashboardPayloadToJSON,
    PublicRawStringPayloadToJSON,
    AccountInformationResponseFromJSON,
    ObjectIdResponseFromJSON,
    ObjectNoResponseFromJSON,
    ProviderClaimEligibilityFromJSON,
    TemporaryUrlFromJSON,
} from '../models';

export interface GetPlaidFailureRequest {
    id: string;
    key: string;
}

export interface GetPlaidSessionLinkRequest {
    id: string;
    sessionId: string;
}

export interface GetPlaidSuccessRequest {
    id: string;
    key: string;
    token: string;
    account: string;
}

export interface GetPublicAccountInformationRequest {
    id: Array<string>;
}

export interface GetStripeFailureRequest {
    id: string;
    key: string;
}

export interface GetStripeSuccessRequest {
    id: string;
    key: string;
}

export interface PostCodingWebhookRequest {
    publicRawStringPayload: PublicRawStringPayload;
}

export interface PostElationWebhookRequest {
    publicRawStringPayload: PublicRawStringPayload;
}

export interface PostGeneratePatientDashboardRequest {
    publicPatientDashboardPayload: PublicPatientDashboardPayload;
}

export interface PostHealthieWebhookRequest {
    publicRawStringPayload: PublicRawStringPayload;
}

export interface PostInboxWebhookRequest {
    publicRawStringPayload: PublicRawStringPayload;
}

export interface PostPublicHL7ADTA03ClaimRequest {
    body: string;
}

export interface PostPublicHL7ADTA03EligibilityRequest {
    body: string;
}

export interface PostPublicHL7DFT03ClaimRequest {
    body: string;
}

export interface PostPublicX12837HealthCareClaimRequest {
    xSecurityToken: string;
    body: string;
}

export interface PostStripeWebhookRequest {
    publicRawStringPayload: PublicRawStringPayload;
}

export interface RedirectUrlShortenerRequest {
    redirectId: string;
}

/**
 * no description
 */
export class PublicApi extends runtime.BaseAPI {

    /**
     * Get plaid setup failure display or redirect
     * Get plaid setup failure display or redirect
     */
    async getPlaidFailureRaw(requestParameters: GetPlaidFailureRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPlaidFailure.');
        }

        if (requestParameters['key'] === null || requestParameters['key'] === undefined) {
            throw new runtime.RequiredError('key','Required parameter requestParameters.key was null or undefined when calling getPlaidFailure.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/public/plaid_setup/failure`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get plaid setup failure display or redirect
     * Get plaid setup failure display or redirect
     */
    async getPlaidFailure(requestParameters: GetPlaidFailureRequest): Promise<string> {
        const response = await this.getPlaidFailureRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a confirmation of the plaid session link
     * Get a confirmation of the plaid session link
     */
    async getPlaidSessionLinkRaw(requestParameters: GetPlaidSessionLinkRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPlaidSessionLink.');
        }

        if (requestParameters['sessionId'] === null || requestParameters['sessionId'] === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getPlaidSessionLink.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.sessionId !== undefined) {
            queryParameters['session_id'] = requestParameters.sessionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/public/plaid_setup/link_session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Get a confirmation of the plaid session link
     * Get a confirmation of the plaid session link
     */
    async getPlaidSessionLink(requestParameters: GetPlaidSessionLinkRequest): Promise<ObjectNoResponse> {
        const response = await this.getPlaidSessionLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get plaid setup success display or redirect
     * Get plaid setup success display or redirect
     */
    async getPlaidSuccessRaw(requestParameters: GetPlaidSuccessRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPlaidSuccess.');
        }

        if (requestParameters['key'] === null || requestParameters['key'] === undefined) {
            throw new runtime.RequiredError('key','Required parameter requestParameters.key was null or undefined when calling getPlaidSuccess.');
        }

        if (requestParameters['token'] === null || requestParameters['token'] === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling getPlaidSuccess.');
        }

        if (requestParameters['account'] === null || requestParameters['account'] === undefined) {
            throw new runtime.RequiredError('account','Required parameter requestParameters.account was null or undefined when calling getPlaidSuccess.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }

        if (requestParameters.token !== undefined) {
            queryParameters['token'] = requestParameters.token;
        }

        if (requestParameters.account !== undefined) {
            queryParameters['account'] = requestParameters.account;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/public/plaid_setup/success`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get plaid setup success display or redirect
     * Get plaid setup success display or redirect
     */
    async getPlaidSuccess(requestParameters: GetPlaidSuccessRequest): Promise<string> {
        const response = await this.getPlaidSuccessRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get public account information
     * Get public account information
     */
    async getPublicAccountInformationRaw(requestParameters: GetPublicAccountInformationRequest): Promise<runtime.ApiResponse<AccountInformationResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPublicAccountInformation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/public/account_information`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountInformationResponseFromJSON(jsonValue));
    }

    /**
     * Get public account information
     * Get public account information
     */
    async getPublicAccountInformation(requestParameters: GetPublicAccountInformationRequest): Promise<AccountInformationResponse> {
        const response = await this.getPublicAccountInformationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get stripe setup failure display or redirect
     * Get stripe setup failure display or redirect
     */
    async getStripeFailureRaw(requestParameters: GetStripeFailureRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getStripeFailure.');
        }

        if (requestParameters['key'] === null || requestParameters['key'] === undefined) {
            throw new runtime.RequiredError('key','Required parameter requestParameters.key was null or undefined when calling getStripeFailure.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/public/stripe_setup/failure`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get stripe setup failure display or redirect
     * Get stripe setup failure display or redirect
     */
    async getStripeFailure(requestParameters: GetStripeFailureRequest): Promise<string> {
        const response = await this.getStripeFailureRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get stripe setup success display or redirect
     * Get stripe setup success display or redirect
     */
    async getStripeSuccessRaw(requestParameters: GetStripeSuccessRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getStripeSuccess.');
        }

        if (requestParameters['key'] === null || requestParameters['key'] === undefined) {
            throw new runtime.RequiredError('key','Required parameter requestParameters.key was null or undefined when calling getStripeSuccess.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/public/stripe_setup/success`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get stripe setup success display or redirect
     * Get stripe setup success display or redirect
     */
    async getStripeSuccess(requestParameters: GetStripeSuccessRequest): Promise<string> {
        const response = await this.getStripeSuccessRaw(requestParameters);
        return await response.value();
    }

    /**
     * Coding webhook endpoint
     * Coding webhook endpoint
     */
    async postCodingWebhookRaw(requestParameters: PostCodingWebhookRequest): Promise<runtime.ApiResponse<ObjectIdResponse>> {
        if (requestParameters['publicRawStringPayload'] === null || requestParameters['publicRawStringPayload'] === undefined) {
            throw new runtime.RequiredError('publicRawStringPayload','Required parameter requestParameters.publicRawStringPayload was null or undefined when calling postCodingWebhook.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/public/coding_webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublicRawStringPayloadToJSON(requestParameters['publicRawStringPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectIdResponseFromJSON(jsonValue));
    }

    /**
     * Coding webhook endpoint
     * Coding webhook endpoint
     */
    async postCodingWebhook(requestParameters: PostCodingWebhookRequest): Promise<ObjectIdResponse> {
        const response = await this.postCodingWebhookRaw(requestParameters);
        return await response.value();
    }

    /**
     * Elation webhook endpoint
     * Elation webhook endpoint
     */
    async postElationWebhookRaw(requestParameters: PostElationWebhookRequest): Promise<runtime.ApiResponse<ObjectIdResponse>> {
        if (requestParameters['publicRawStringPayload'] === null || requestParameters['publicRawStringPayload'] === undefined) {
            throw new runtime.RequiredError('publicRawStringPayload','Required parameter requestParameters.publicRawStringPayload was null or undefined when calling postElationWebhook.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/public/elation_webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublicRawStringPayloadToJSON(requestParameters['publicRawStringPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectIdResponseFromJSON(jsonValue));
    }

    /**
     * Elation webhook endpoint
     * Elation webhook endpoint
     */
    async postElationWebhook(requestParameters: PostElationWebhookRequest): Promise<ObjectIdResponse> {
        const response = await this.postElationWebhookRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generates the patient dashboard url for a customer
     * Generates the patient dashboard url for a customer
     */
    async postGeneratePatientDashboardRaw(requestParameters: PostGeneratePatientDashboardRequest): Promise<runtime.ApiResponse<TemporaryUrl>> {
        if (requestParameters['publicPatientDashboardPayload'] === null || requestParameters['publicPatientDashboardPayload'] === undefined) {
            throw new runtime.RequiredError('publicPatientDashboardPayload','Required parameter requestParameters.publicPatientDashboardPayload was null or undefined when calling postGeneratePatientDashboard.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/public/patient_dashboard`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublicPatientDashboardPayloadToJSON(requestParameters['publicPatientDashboardPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryUrlFromJSON(jsonValue));
    }

    /**
     * Generates the patient dashboard url for a customer
     * Generates the patient dashboard url for a customer
     */
    async postGeneratePatientDashboard(requestParameters: PostGeneratePatientDashboardRequest): Promise<TemporaryUrl> {
        const response = await this.postGeneratePatientDashboardRaw(requestParameters);
        return await response.value();
    }

    /**
     * Healthie webhook endpoint
     * Healthie webhook endpoint
     */
    async postHealthieWebhookRaw(requestParameters: PostHealthieWebhookRequest): Promise<runtime.ApiResponse<ObjectIdResponse>> {
        if (requestParameters['publicRawStringPayload'] === null || requestParameters['publicRawStringPayload'] === undefined) {
            throw new runtime.RequiredError('publicRawStringPayload','Required parameter requestParameters.publicRawStringPayload was null or undefined when calling postHealthieWebhook.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/public/healthie_webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublicRawStringPayloadToJSON(requestParameters['publicRawStringPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectIdResponseFromJSON(jsonValue));
    }

    /**
     * Healthie webhook endpoint
     * Healthie webhook endpoint
     */
    async postHealthieWebhook(requestParameters: PostHealthieWebhookRequest): Promise<ObjectIdResponse> {
        const response = await this.postHealthieWebhookRaw(requestParameters);
        return await response.value();
    }

    /**
     * Inbox webhook endpoint
     * Inbox webhook endpoint
     */
    async postInboxWebhookRaw(requestParameters: PostInboxWebhookRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['publicRawStringPayload'] === null || requestParameters['publicRawStringPayload'] === undefined) {
            throw new runtime.RequiredError('publicRawStringPayload','Required parameter requestParameters.publicRawStringPayload was null or undefined when calling postInboxWebhook.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/public/inbox_webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublicRawStringPayloadToJSON(requestParameters['publicRawStringPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Inbox webhook endpoint
     * Inbox webhook endpoint
     */
    async postInboxWebhook(requestParameters: PostInboxWebhookRequest): Promise<ObjectNoResponse> {
        const response = await this.postInboxWebhookRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a claim from an hl7 adt a08 document
     * Update a claim from an hl7 adt a08 document
     */
    async postPublicHL7ADTA03ClaimRaw(requestParameters: PostPublicHL7ADTA03ClaimRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postPublicHL7ADTA03Claim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'text/plain';

        const response = await this.request({
            path: `/public/claim/hl7/v231/adt/a08`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update a claim from an hl7 adt a08 document
     * Update a claim from an hl7 adt a08 document
     */
    async postPublicHL7ADTA03Claim(requestParameters: PostPublicHL7ADTA03ClaimRequest): Promise<string> {
        const response = await this.postPublicHL7ADTA03ClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an claim from an hl7 adt a08 document
     * Create an eligibility from an hl7 adt a08 document
     */
    async postPublicHL7ADTA03EligibilityRaw(requestParameters: PostPublicHL7ADTA03EligibilityRequest): Promise<runtime.ApiResponse<ProviderClaimEligibility>> {
        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postPublicHL7ADTA03Eligibility.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'text/plain';

        const response = await this.request({
            path: `/public/eligibility/hl7/v231/adt/a08`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClaimEligibilityFromJSON(jsonValue));
    }

    /**
     * Create an claim from an hl7 adt a08 document
     * Create an eligibility from an hl7 adt a08 document
     */
    async postPublicHL7ADTA03Eligibility(requestParameters: PostPublicHL7ADTA03EligibilityRequest): Promise<ProviderClaimEligibility> {
        const response = await this.postPublicHL7ADTA03EligibilityRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a claim from an hl7 dft p03 document
     * Create a claim from an hl7 dft p03 document
     */
    async postPublicHL7DFT03ClaimRaw(requestParameters: PostPublicHL7DFT03ClaimRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postPublicHL7DFT03Claim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'text/plain';

        const response = await this.request({
            path: `/public/claim/hl7/v231/dft/p03`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a claim from an hl7 dft p03 document
     * Create a claim from an hl7 dft p03 document
     */
    async postPublicHL7DFT03Claim(requestParameters: PostPublicHL7DFT03ClaimRequest): Promise<string> {
        const response = await this.postPublicHL7DFT03ClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a claim from an x12 837 document
     * Create a claim from an x12 837 document
     */
    async postPublicX12837HealthCareClaimRaw(requestParameters: PostPublicX12837HealthCareClaimRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['xSecurityToken'] === null || requestParameters['xSecurityToken'] === undefined) {
            throw new runtime.RequiredError('xSecurityToken','Required parameter requestParameters.xSecurityToken was null or undefined when calling postPublicX12837HealthCareClaim.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postPublicX12837HealthCareClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/edi-x12';

        if (requestParameters.xSecurityToken !== undefined && requestParameters.xSecurityToken !== null) {
            headerParameters['x-security-token'] = String(requestParameters.xSecurityToken);
        }

        const response = await this.request({
            path: `/public/claim/x12/5010/837`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a claim from an x12 837 document
     * Create a claim from an x12 837 document
     */
    async postPublicX12837HealthCareClaim(requestParameters: PostPublicX12837HealthCareClaimRequest): Promise<string> {
        const response = await this.postPublicX12837HealthCareClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Stripe webhook endpoint
     * Stripe webhook endpoint
     */
    async postStripeWebhookRaw(requestParameters: PostStripeWebhookRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['publicRawStringPayload'] === null || requestParameters['publicRawStringPayload'] === undefined) {
            throw new runtime.RequiredError('publicRawStringPayload','Required parameter requestParameters.publicRawStringPayload was null or undefined when calling postStripeWebhook.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/public/stripe_webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublicRawStringPayloadToJSON(requestParameters['publicRawStringPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Stripe webhook endpoint
     * Stripe webhook endpoint
     */
    async postStripeWebhook(requestParameters: PostStripeWebhookRequest): Promise<ObjectNoResponse> {
        const response = await this.postStripeWebhookRaw(requestParameters);
        return await response.value();
    }

    /**
     * URL Shortener redirect
     * URL Shortener redirect
     */
    async redirectUrlShortenerRaw(requestParameters: RedirectUrlShortenerRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['redirectId'] === null || requestParameters['redirectId'] === undefined) {
            throw new runtime.RequiredError('redirectId','Required parameter requestParameters.redirectId was null or undefined when calling redirectUrlShortener.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/public/redirect/{redirectId}`.replace(`{${"redirectId"}}`, encodeURIComponent(String(requestParameters.redirectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * URL Shortener redirect
     * URL Shortener redirect
     */
    async redirectUrlShortener(requestParameters: RedirectUrlShortenerRequest): Promise<string> {
        const response = await this.redirectUrlShortenerRaw(requestParameters);
        return await response.value();
    }

}
